export class ScreeningStateModel {
  idTrade?: string;
  originalIMEI?: string;
  idOperation?: string;
  idSubCategory?: string;
  postalCode?: string;
  screeningStep?: string;
  blobRec?: any;
  base64File?: string;
  videoName?: string;
  fileType?: string;
  hasDivergenceReport?: boolean;
  isReappraisal?: boolean;
  reasonOfReappraisal?: string;
  isRepair?: boolean;
  classificationType?: string;
}

export class RecordingStateModel {
  idTrade: string;
}

export class SetPostalCode {
  static readonly type = '[Screening] Set Postal Code';
  constructor(public payload: string) {}
}

export class SetTrade {
  static readonly type = '[Screening] Set Info Trade';
  constructor(public payload: ScreeningStateModel) {}
}

export class SetRecording {
  static readonly type = '[Screening] Set Recording';
  constructor(public payload: any) {}
}
export class SetHasDivergenceReport {
  static readonly type = '[Screening] Set if checklist has divergence report option';
  constructor(public payload: boolean) {}
}

export class UpdateReappraisal {
  static readonly type = '[Screening] Update screening in case is reappraisal type';
  constructor(public payload: { isReappraisal: boolean; reasonOfReappraisal: string }) {}
}

export class SetQuestionsDynamic {
  static readonly type = '[Screening] SetQuestionsDynamic Screening';
  constructor(public payload: any) {}
}
